import styled from "styled-components";
import breakpoints from "../../../../constants/breakpoints";

export const Styles = styled.div`
  width: ${({ propWidth }) => (propWidth ? propWidth : "100% !important")};

  .form-label {
    font-weight: 400;
    color: #212121 !important;
    font-size: 18px !important;
  }
  input[type="text"]:focus {
    background-color: transparent !important;
  }
  input[type="text"] {
    background-color: transparent !important;
    min-height: 39px !important;
  }
  .is-required {
    &::after {
      content: " *";
      color: var(--main-color);
      font-weight: bold;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    width: 100% !important;
  }
`;
